import Model from './Model'

export default class ReportField extends Model {
  id: number
  name: string
  title: string
  type: string
  titleKey: string
  required: boolean
  dropoff: boolean
  dropoffValue: string
  isIdentifier: boolean
  readonly: boolean
  value: string
  edited: boolean = false
  listLabels: []
  listValues: []
  picturePath: string
  dropoffPicturePath: string
  annotations = []

  constructor(field, locale) {
    super({})
    this.id = field.id
    this.name = field.name
    this.title = this.translateField(field._title, locale)
    this.titleKey = field.titleKey
    this.type = field.type
    this.required = field.required
    this.value = field.value
    this.dropoff = field.dropoff
    this.dropoffValue = field.dropoff_value
    this.readonly = field.readonly || false

    // TODO check identifier is not identifer
    this.isIdentifier = field.identifier || false

    if (field.type === 'list') {
      this.listLabels = field.parameters._list.map((label) => this.translateField(label, locale))
      this.listValues = field.parameters._list.map((label) => label.id)
    }

    if (field.type === 'boolean') {
      this.value = this.value ? JSON.parse(this.value) : null
      this.dropoffValue = this.dropoffValue ? JSON.parse(this.dropoffValue) : null
    }

    if (field.type === 'supports') {
      this.value = field._picture ? field._picture.path : null
      this.dropoffValue = field._dropoff_picture ? field._dropoff_picture.path : null
      this.picturePath = field._picture ? field._picture.path : null
      this.dropoffPicturePath = field._dropoff_picture ? field._dropoff_picture.path : null
    }

    // Change Type for phone number and zip code
    if (field.name === 'phone_number' || field.name === 'zip_code') {
      this.type = 'text'
    }
  }
}
